/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { call, put, takeLatest, all, takeEvery } from "redux-saga/effects";
import * as aggregateAction from "./actions";
import {
  FetchCurrentBill,
  FetchCurrentBreakDown,
  FetchCountSummary,
  FetchTotalBreak,
  FetchPreviousBreakDown,
  FetchAllRates,
  FetchAllStandardRates,
  SetRate,
  SetStandardRate,
  EditCustomRate,
  EditStandardRate,
  getCreditHistory,
  getBillingHistory,
  downloadInvoice,
  creditAdjustment,
  FetchStandardRatesList,
  FetchAStandardRate,
  DeleteStandardRate,
  FetchCustomRatesList,
  CreateStandardRate,
  FetchACustomRate,
  CreateCustomRate,
  FetchCurrentStandardRate,
  DeleteCustomRate,
  FetchACustomRateStatus,
  FetchAStandardRateStatus,
  FetchMediatailorDataUsage,
} from "./services";

export function* adjustCreditSaga(action) {
  try {
    const response = yield call(creditAdjustment, action.payload);
    if (response && response.data && response.data.success) {
      yield put(aggregateAction.CreditAdjustmentSuccess("success"));
    } else {
      const message =
        response && response.data && response.data.message
          ? response.data.message
          : "Something went wrong. Please try later";
      yield put(aggregateAction.CreditAdjustmentFailed(message));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(aggregateAction.CreditAdjustmentFailed(error));
  }
}
export function* downloadInvoiceSaga(action) {
  try {
    const response = yield call(downloadInvoice, action.payload);
    if (response && response.data) {
      yield put(aggregateAction.DownloadInvoiceSuccess("success"));
    } else {
      const message =
        response && response.data && response.data.message
          ? response.data.message
          : "Something went wrong. Please try later";
      yield put(aggregateAction.DownloadInvoiceFailed(message));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(aggregateAction.DownloadInvoiceFailed(error));
  }
}
// worker saga: makes the api call when watcher saga sees the action
export function* fetchCurrentBillSaga(action) {
  try {
    const response = yield call(FetchCurrentBill, action.payload);

    const usage = response.data && response.data.data ? response.data.data : [];
    yield put(aggregateAction.FetchCurrentBillSuccess(usage));
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(aggregateAction.FetchCurrentBillFailed(error));
  }
}

export function* fetchCurrentBreakDownSaga(action) {
  try {
    const response = yield call(FetchCurrentBreakDown, action.payload);
    const breakDown =
      response.data && response.data.data ? response.data.data : [];
    yield put(aggregateAction.FetchCompanyEvolutionBreakSuccess(breakDown));
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(aggregateAction.FetchCompanyEvolutionBreakFailed(error));
  }
}

export function* FetchCountSummarySaga(action) {
  /* istanbul ignore next */
  try {
    const response = yield call(FetchCountSummary, action.payload);
    const summary =
      response.data && response.data.data ? response.data.data : {};
    yield put(aggregateAction.FetchCountSummarySuccess(summary));
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(aggregateAction.FetchCountSummaryFailed(error));
  }
}

export function* FetchTotalBreakSaga(action) {
  /* istanbul ignore next */
  try {
    const response = yield call(FetchTotalBreak, action.payload);
    const totalBreakDown =
      response.data && response.data.data ? response.data.data : {};
    yield put(
      aggregateAction.FetchTotalBreakSuccess({
        [`${action.payload.isMonthly ? "monthly" : "daily"}`]: totalBreakDown,
      }),
      // aggregateAction.FetchTotalBreakSuccess(totalBreakDown)
    );
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(aggregateAction.FetchTotalBreakFailed(error));
  }
}
export function* fetchPreviousBreakDownSaga(action) {
  try {
    const response = yield call(FetchPreviousBreakDown, action.payload);
    const breakDown =
      response.data && response.data.data ? response.data.data : [];
    yield put(
      aggregateAction.FetchPreviousEvolutionBreakSuccess({
        [`${action.payload.isMonthly ? "monthly" : "daily"}`]: breakDown,
      }),
    );
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(aggregateAction.FetchPreviousEvolutionBreakFailed(error));
  }
}
export function* fetchAllRatesSaga(action) {
  try {
    const response = yield call(FetchAllRates, action.payload);
    const allDates = response.data || {};
    yield put(aggregateAction.FetchAllRatesSuccess(allDates));
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(aggregateAction.FetchAllRatesFailed(error));
  }
}
export function* fetchAllStandardRatesSaga(action) {
  try {
    const response = yield call(FetchAllStandardRates, action.payload);
    const allData = response.data || {};
    yield put(aggregateAction.FetchAllStandardRatesSuccess(allData));
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(aggregateAction.FetchAllStandardRatesFailed(error));
  }
}
export function* setRateSaga(action) {
  try {
    const response = yield call(SetRate, action.payload);
    const rateResponse = response.data || {};
    if (rateResponse.success === false) {
      yield put(aggregateAction.SetRateFailed(rateResponse));
    } else {
      yield put(aggregateAction.SetRateSuccess(rateResponse));
    }
  } catch (error) {
    yield put(aggregateAction.SetRateFailed(error));
  }
}
export function* setStandardRateSaga(action) {
  try {
    const response = yield call(SetStandardRate, action.payload);
    const rateResponse = response.data || {};
    if (rateResponse.success === false) {
      yield put(aggregateAction.SetStandardRateFailed(rateResponse));
    } else {
      yield put(aggregateAction.SetStandardRateSuccess(rateResponse));
    }
  } catch (error) {
    yield put(aggregateAction.SetStandardRateFailed(error));
  }
}
export function* updateCustomRateSaga(action) {
  try {
    const response = yield call(EditCustomRate, action.payload);
    const rateResponse = response.data || {};
    if (rateResponse.success === false) {
      yield put(aggregateAction.UpdateCustomRateFailed(rateResponse));
    } else {
      yield put(aggregateAction.UpdateCustomRateSuccess(rateResponse));
    }
  } catch (error) {
    yield put(aggregateAction.UpdateCustomRateFailed(error));
  }
}
export function* updateStandardRateSaga(action) {
  try {
    const response = yield call(EditStandardRate, action.payload);
    const rateResponse = response.data || {};
    if (rateResponse.success === false) {
      yield put(aggregateAction.UpdateStandardRateFailed(rateResponse));
    } else {
      yield put(aggregateAction.UpdateStandardRateSuccess(rateResponse));
    }
  } catch (error) {
    yield put(aggregateAction.UpdateStandardRateFailed(error));
  }
}
export function* fetchCreditHistorySaga(action) {
  try {
    const response = yield call(getCreditHistory, action.payload);
    const creditHistory = response.data || {};
    yield put(aggregateAction.FetchCreditHistorySuccess(creditHistory));
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(aggregateAction.FetchCreditHistoryFailed(error));
  }
}
export function* fetchBillingHistorySaga(action) {
  try {
    const response = yield call(getBillingHistory, action.payload);
    const billingHistory = response.data || {};
    yield put(aggregateAction.FetchBillingHistorySuccess(billingHistory));
  } catch (error) {
    yield put(aggregateAction.FetchBillingHistoryFailed(error));
  }
}
export function* fetchStandardRatesListSaga(action) {
  try {
    const response = yield call(FetchStandardRatesList, action.payload);
    if (response?.data?.success) {
      yield put(
        aggregateAction.FetchStandardRatesListSuccess(response.data.data),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(aggregateAction.FetchStandardRatesListFailed(error));
  }
}

export function* loadMoreStandardRatesSaga(action) {
  try {
    const response = yield call(FetchStandardRatesList, action.payload);
    yield put(aggregateAction.LoadMoreStandardRateSuccess(response.data.data));
  } catch (error) {
    yield put(aggregateAction.LoadMoreStandardRateFailed(error));
  }
}
export function* fetchAStandardRatesSaga(action) {
  try {
    const response = yield call(FetchAStandardRate, action.payload);
    if (response?.data?.success) {
      yield put(aggregateAction.FetchAStandardRatesSuccess(response.data.data));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(aggregateAction.FetchAStandardRatesFailed(error));
  }
}
export function* deleteStandardRateSaga(action) {
  try {
    const response = yield call(DeleteStandardRate, action.payload);
    if (response?.data?.success) {
      yield put(aggregateAction.DeleteStandardRateSuccess(response.data));
    } else {
      yield put(aggregateAction.DeleteStandardRateFailed(response.data));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(aggregateAction.DeleteStandardRateFailed(error));
  }
}
export function* fetchCustomRatesListSaga(action) {
  try {
    const response = yield call(FetchCustomRatesList, action.payload);
    if (response?.data?.success) {
      yield put(
        aggregateAction.FetchCustomRatesListSuccess(response.data.data),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(aggregateAction.FetchCustomRatesListFailed(error));
  }
}
export function* loadMoreCustomRatesSaga(action) {
  try {
    const response = yield call(FetchCustomRatesList, action.payload);
    yield put(aggregateAction.LoadMoreCustomRateSuccess(response.data.data));
  } catch (error) {
    yield put(aggregateAction.LoadMoreCustomRateFailed(error));
  }
}
export function* createStandardRateSaga(action) {
  try {
    const response = yield call(CreateStandardRate, action.payload);
    if (response?.data?.success) {
      yield put(aggregateAction.CreateStandardRateSuccess(response.data));
    } else {
      yield put(aggregateAction.CreateStandardRateFailed(response.data));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(aggregateAction.CreateStandardRateFailed(error));
  }
}
export function* fetchACustomRatesSaga(action) {
  try {
    const response = yield call(FetchACustomRate, action.payload);
    if (response?.data?.success) {
      yield put(aggregateAction.FetchACustomRatesSuccess(response.data.data));
    } else {
      yield put(aggregateAction.FetchACustomRatesFailed(response.data));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(aggregateAction.FetchACustomRatesFailed(error));
  }
}
export function* createCustomRateSaga(action) {
  try {
    const response = yield call(CreateCustomRate, action.payload);
    if (response?.data?.success) {
      yield put(aggregateAction.CreateCustomRateSuccess(response.data));
    } else {
      yield put(aggregateAction.CreateCustomRateFailed(response.data));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(aggregateAction.CreateCustomRateFailed(error));
  }
}
export function* fetchCurrentStandardRateSaga(action) {
  try {
    const response = yield call(FetchCurrentStandardRate, action.payload);
    if (response?.data?.success) {
      yield put(
        aggregateAction.FetchCurrentStandardRateSuccess(response.data.data),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(aggregateAction.FetchCurrentStandardRateFailed(error));
  }
}
export function* deleteCustomRateSaga(action) {
  try {
    const response = yield call(DeleteCustomRate, action.payload);
    if (response?.data?.success) {
      yield put(aggregateAction.DeleteCustoRateSuccess(response.data));
    } else {
      yield put(aggregateAction.DeleteCustomRateFailed(response.data));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(aggregateAction.DeleteCustomRateFailed(error));
  }
}
export function* fetchACustomRateStatusSaga(action) {
  try {
    const response = yield call(FetchACustomRateStatus, action.payload);
    if (response?.data?.success) {
      yield put(
        aggregateAction.FetchACustomRateStatusSuccess(response.data.data),
      );
    } else {
      yield put(aggregateAction.FetchACustomRateStatusFailed(response.data));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(aggregateAction.FetchACustomRateStatusFailed(error));
  }
}
export function* fetchAStandardRateStatusSaga(action) {
  try {
    const response = yield call(FetchAStandardRateStatus, action.payload);
    if (response?.data?.success) {
      yield put(
        aggregateAction.FetchAStandardRateStatusSuccess(response.data.data),
      );
    } else {
      yield put(aggregateAction.FetchAStandardRateStatusFailed(response.data));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(aggregateAction.FetchAStandardRateStatusFailed(error));
  }
}
// watcher saga: watches for actions dispatched to the store, starts worker saga
export function* aggregateWatcher() {
  yield all([
    takeLatest(aggregateAction.types.FETCH_CURRENT_BILL, fetchCurrentBillSaga),
    takeLatest(
      aggregateAction.types.FETCH_COMPANY_EVOLUTION_BREAK,
      fetchCurrentBreakDownSaga,
    ),
    takeLatest(
      aggregateAction.types.FETCH_COUNT_SUMMARY,
      FetchCountSummarySaga,
    ),
    takeEvery(aggregateAction.types.FETCH_TOTAL_BREAK, FetchTotalBreakSaga),
    takeLatest(
      aggregateAction.types.FETCH_COMPANY_PREV_EVOLUTION_BREAK,
      fetchPreviousBreakDownSaga,
    ),
    takeLatest(aggregateAction.types.FETCH_ALL_RATES, fetchAllRatesSaga),
    takeLatest(
      aggregateAction.types.FETCH_ALL_STANDARD_RATES,
      fetchAllStandardRatesSaga,
    ),
    takeLatest(aggregateAction.types.SET_RATE, setRateSaga),
    takeLatest(aggregateAction.types.SET_STANDARD_RATE, setStandardRateSaga),
    takeLatest(aggregateAction.types.UPDATE_CUSTOM_RATE, updateCustomRateSaga),
    takeLatest(
      aggregateAction.types.UPDATE_STANDARD_RATE,
      updateStandardRateSaga,
    ),
    takeLatest(
      aggregateAction.types.FETCH_CREDIT_HISTORY,
      fetchCreditHistorySaga,
    ),
    takeLatest(
      aggregateAction.types.FETCH_BILLING_HISTORY,
      fetchBillingHistorySaga,
    ),
    takeLatest(aggregateAction.types.ADJUST_CREDIT, adjustCreditSaga),
    takeLatest(aggregateAction.types.DOWNLOAD_INVOICE, downloadInvoiceSaga),
    takeLatest(
      aggregateAction.types.FETCH_STANDARD_RATES_LIST,
      fetchStandardRatesListSaga,
    ),
    takeEvery(
      aggregateAction.types.LOAD_MORE_STANDARD_RATES,
      loadMoreStandardRatesSaga,
    ),
    takeLatest(
      aggregateAction.types.FETCH_A_STANDARD_RATES,
      fetchAStandardRatesSaga,
    ),
    takeLatest(
      aggregateAction.types.DELETE_STANDARD_RATE,
      deleteStandardRateSaga,
    ),
    takeLatest(
      aggregateAction.types.FETCH_CUSTOM_RATES_LIST,
      fetchCustomRatesListSaga,
    ),
    takeEvery(
      aggregateAction.types.LOAD_MORE_CUSTOM_RATES,
      loadMoreCustomRatesSaga,
    ),
    takeLatest(
      aggregateAction.types.CREATE_STANDARD_RATE,
      createStandardRateSaga,
    ),
    takeLatest(
      aggregateAction.types.FETCH_A_CUSTOM_RATES,
      fetchACustomRatesSaga,
    ),
    takeLatest(aggregateAction.types.CREATE_CUSTOM_RATE, createCustomRateSaga),
    takeLatest(
      aggregateAction.types.FETCH_CURRENT_STANDARD_RATE,
      fetchCurrentStandardRateSaga,
    ),
    takeLatest(aggregateAction.types.DELETE_CUSTOM_RATE, deleteCustomRateSaga),
    takeLatest(
      aggregateAction.types.FETCH_A_CUSTOM_RATE_STATUS,
      fetchACustomRateStatusSaga,
    ),
    takeLatest(
      aggregateAction.types.FETCH_A_STANDARD_RATE_STATUS,
      fetchAStandardRateStatusSaga,
    ),
    takeLatest(
      aggregateAction.types.FETCH_MEDIATAILOR_DATA_USAGE,
      FetchMediatailorAppSessionDataUsageSaga,
    ),
  ]);
}
export function* FetchMediatailorAppSessionDataUsageSaga(action) {
  try {
    const response = yield call(FetchMediatailorDataUsage, action.payload);
    if (response?.data?.success) {
      yield put(aggregateAction.FetchMediatailorDataUsageSuccess(response));
    } else {
      yield put(aggregateAction.FetchMediatailorDataUsageFailed(response));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(aggregateAction.FetchMediatailorDataUsageFailed(error));
  }
}
